/** Centralised data-testid registry. */
export const HOME = {
  hero: "home-hero",
  searchInput: "home-search-input",
  sendBtn: "home-send-btn",
  promptChip: (i) => `home-prompt-chip-${i}`,
  navExplorer: "home-nav-explorer",
  navCarte: "home-nav-carte",
  navCepages: "home-nav-cepages",
  navAppellations: "home-nav-appellations",
  navCarnet: "home-nav-carnet",
  navCours: "home-nav-cours",
};

export const NAV = {
  logo: "nav-logo",
  cepages: "nav-link-cepages",
  appellations: "nav-link-appellations",
  carnet: "nav-link-carnet",
  pro: "nav-link-pro",
  chat: "nav-link-chat",
  login: "nav-link-login",
  register: "nav-link-register",
  logout: "nav-logout",
  admin: "nav-link-admin",
  user: "nav-user-menu",
};

export const CHAT = {
  input: "chat-input",
  send: "chat-send",
  messageUser: (i) => `chat-msg-user-${i}`,
  messageAssistant: (i) => `chat-msg-assistant-${i}`,
  reset: "chat-reset",
};

export const ATLAS = {
  card: (slug) => `atlas-card-${slug}`,
  search: "atlas-search",
  detailMapBtn: "atlas-detail-map-btn",
  detailEmbedBtn: "atlas-detail-embed-btn",
};

export const CARNET = {
  newBtn: "carnet-new-btn",
  form: "carnet-form",
  fieldName: "carnet-name",
  fieldType: "carnet-type",
  fieldScore: "carnet-score",
  fieldRobe: "carnet-robe",
  fieldNez: "carnet-nez",
  fieldBouche: "carnet-bouche",
  fieldComment: "carnet-comment",
  submit: "carnet-submit",
  item: (id) => `carnet-item-${id}`,
  delete: (id) => `carnet-delete-${id}`,
};

export const AUTH = {
  email: "auth-email",
  password: "auth-password",
  name: "auth-name",
  submit: "auth-submit",
  toggle: "auth-toggle",
};

export const PRO = {
  cta: "pro-cta",
  form: "pro-form",
  name: "pro-name",
  email: "pro-email",
  company: "pro-company",
  website: "pro-website",
  message: "pro-message",
  submit: "pro-submit",
};

export const ADMIN = {
  title: "admin-doc-title",
  source: "admin-doc-source",
  content: "admin-doc-content",
  add: "admin-doc-add",
  upload: "admin-doc-upload",
  delete: (id) => `admin-doc-delete-${id}`,
  list: "admin-doc-list",
};
